import UnfoldMoreIcon from '@assets/buttons-icons/expand-up-down.svg?react';
import analyzeLottie from '@assets/meeting/analyze-lottie.json?url';
import palette from '@lib/core/src/theme/palette';
import { Player } from '@lottiefiles/react-lottie-player';
import { Typography, Stack, alpha, styled } from '@mui/material';

import { SelectTemplateButton } from './MeetingOverview/MeetingOverviewStyles';

const TextContainer = styled(Stack)({
  margin: '0 auto',
  alignItems: 'center',
  justifyContent: 'center',
  border: `1px solid ${palette.white}`,
  backgroundColor: alpha(palette.white, 0.3),
  borderRadius: '20px',
  height: '84px',
  width: '256px'
});

const MeetingAnalyzeSkeleton = ({ name }: { name?: string }) => (
  <>
    <Stack sx={{ justifyContent: 'flex-end', flexDirection: 'row', marginBottom: '16px' }}>
      <SelectTemplateButton disabled={true} sx={{ width: 'fit-content' }}>
        {name}{' '}
        <UnfoldMoreIcon
          style={{ marginLeft: '5px', color: palette.grey['600'] }}
          fontSize="small"
        />
      </SelectTemplateButton>
    </Stack>

    <Player
      src={analyzeLottie}
      loop
      autoplay
      style={{ height: 'calc(100% - 27px - 64px - 36px)' }}
    />
    <TextContainer>
      <Typography sx={{ fontSize: '13px', fontWeight: 600 }}>Summary is generating.</Typography>
      <Typography sx={{ fontSize: '12px', color: palette.grey[400] }}>
        This may take a while...
      </Typography>
    </TextContainer>
  </>
);

export default MeetingAnalyzeSkeleton;
